<template>
    <v-btn :disabled="!deveHabilitarBotoes" outline color="primary" @click.stop="$emit('juntarDocumentosEmLote')">
        <v-icon left size="15">fas fa-file-export</v-icon>
        Juntar
    </v-btn>
</template>

<script>
export default {
    name: 'BotaoJuntarDocumentoEmLote',
    props:['deveHabilitarBotoes']
}
</script>

<style scoped lang="stylus">

</style>